export default __webpack_public_path__ + "static/media/message.4757acbb.png";